import { render, staticRenderFns } from "./editItemsReply.vue?vue&type=template&id=3def9703&scoped=true&"
import script from "./editItemsReply.vue?vue&type=script&lang=js&"
export * from "./editItemsReply.vue?vue&type=script&lang=js&"
import style0 from "./editItemsReply.vue?vue&type=style&index=0&id=3def9703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3def9703",
  null
  
)

export default component.exports